var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"gj-local-time"},[_vm._t("label",function(){return [_c('span',[_vm._v(_vm._s(_vm._f("defaultShow")(_vm.label,'', '：', '')))])]}),_vm._v(_vm._s(_vm.localTimeText)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }